import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [{"q": "Quels services proposez-vous ?", "a": "Nous proposons neuf services : murs et plafonds, après déménagement, après construction, vitres et tapis, logements locatifs, bureaux et locaux commerciaux, restaurants et hôtels, entretien et grand ménage, et intérieur de voiture."}, {"q": "Comment demander une soumission ?", "a": "Appelez le 450 578 1383 ou appelez le 263 355 2601. Écrivez à Entretiennetpro@gmail.com. Le formulaire prépare un courriel ou un texto avec les détails de votre demande."}, {"q": "Proposez-vous un entretien régulier ?", "a": "Oui. L’entretien régulier et le grand ménage font partie de nos services. Contactez-nous pour discuter de la fréquence souhaitée."}, {"q": "Intervenez-vous dans mon secteur ?", "a": "Indiquez votre ville et votre adresse lors de votre demande pour confirmer la disponibilité du service dans votre secteur."}];

const FAQ = () => {
  return (
    <section
      id="faq"
      className="relative bg-white py-24 md:py-32"
      data-testid="faq-section"
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-14 md:mb-16 text-center"
        >
          <span className="divider-tag">FAQ</span>
          <h2 className="mt-6 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#101D2C] leading-[1.02]">
            Questions
            <br />
            <span className="text-[#101D2C]/40">fréquentes.</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-slate-200 last:border-b-0"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left py-6 hover:no-underline group">
                  <span className="font-display font-semibold text-lg md:text-xl text-[#101D2C] pr-4 group-hover:text-[#101D2C]/80 transition-colors">
                    <span className="text-[#58BCFA] mr-4 font-mono text-sm">
                      0{i + 1}
                    </span>
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-base text-[#475569] leading-relaxed pb-6 pl-10">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
